import IndividualDevelopmentPlan from './model';
import LearningResult from './LearningResult';
import Suggestions from './Suggestions';
import DosRejectedComment from './DosRejectedComment';
import { Interval } from 'domain/Interval';
import { moment } from 'omni-common-ui';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'period':
      return [key, Interval.create({
        start: val.startDate,
        end: val.endDate,
      })];
    case 'learningResult':
      return [key, LearningResult.create(val)];
    case 'studentIDPFeedbackSuggestions':
      return [key, Suggestions.create(val)];
    case 'dosRejectedComment':
      return [key, DosRejectedComment.create(val)];
    case 'lastUpdatedTimeUtc':
      return [key, moment.utc(val)];
    default:
      return [key, val];
  }
};

const create = (data) => new IndividualDevelopmentPlan(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/Idp/create.js